import { change as formChange } from 'redux-form';
import { connect } from 'react-redux';
import _ from 'lodash';

import { getSelectOptions } from 'src/reducers/selectOptions';
import { getExtras, getErrors } from 'src/reducers/common/listReducer';
import {
  REDUCER_NAME,
  getUnconfirmedAlertCount,
  getRevisionErrors
} from 'src/reducers/reports/notificationOfBaseAmountRevisions';
import {
  fetchNotificationOfBaseAmountMonthOptions,
  notificationOfBaseAmountMonthsSearchFormSelector,
  isLoading,
  ITEM_NAME_FETCH_NOTIFICATION_OF_BASE_AMOUNT_REVISION_MONTH_OPTIONS
} from 'src/reducers/searchForm';
import { fetchPdfJobStatus } from 'src/reducers/reports/notificationOfBaseAmountRevisionAsync';
import { INITIAL_POLLING_INTERVAL } from 'src/constants/Generals';
import Header from '../components/Header';

const mapStateToProps = state => ({
  revisionYear: getSelectOptions(state, 'revisionYears'),
  yearMonth: notificationOfBaseAmountMonthsSearchFormSelector(state, 'yearMonth'),
  extras: getExtras(REDUCER_NAME, state),
  hasInvalidMonthsErrors: !_.isEmpty(getErrors(REDUCER_NAME, state)),
  revisionErrors: getRevisionErrors(state),
  isOptionsLoading: isLoading(ITEM_NAME_FETCH_NOTIFICATION_OF_BASE_AMOUNT_REVISION_MONTH_OPTIONS, state),
  unconfirmedAlertCount: getUnconfirmedAlertCount(state)
});

const mapDispatchToProps = dispatch => ({
  filterAlertTargets: () => {
    dispatch(formChange('notificationOfBaseAmountMonthSearchForm', 'filterType', 'alert_targets'));
  },
  fetchNotificationOfBaseAmountMonthOptions: () => {
    dispatch(fetchNotificationOfBaseAmountMonthOptions());
  },
  fetchPdfJobStatus: revisionYear => {
    dispatch(fetchPdfJobStatus(INITIAL_POLLING_INTERVAL, revisionYear));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
